import { FC } from 'react';
import classNames from 'classnames';

import { useBemHelper } from 'src/utils/hooks/useBemHelper';
import { UiButton } from 'src/components/UI/Button';
import { ChildrenPropType } from 'src/utils/types';

export type PlusSubscriptionModalButtonProps = {
  children: ChildrenPropType;

  onClick?: () => void;
  className?: string;
  bordered?: boolean;
  noBorder?: boolean;
  loading?: boolean;
  disabled?: boolean;
};

export const PlusSubscriptionModalButton: FC<PlusSubscriptionModalButtonProps> = ({
  children,
  onClick,
  className,
  bordered,
  noBorder,
  loading,
  disabled,
}) => {
  const bemHelper = useBemHelper('plus-subscription-modal-button');

  const modifiers = [];

  if (bordered) {
    modifiers.push('bordered');
  } else if (noBorder) {
    modifiers.push('no-border');
  } else {
    modifiers.push('filled');
  }

  return (
    <UiButton
      customClass
      className={classNames(bemHelper(modifiers), className)}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
    >
      {children}
    </UiButton>
  );
};
